import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

interface BrandMarkProps {
    className?: string
}

const BrandMark: FC<BrandMarkProps> = ({ className }): ReactNode => {
    return (
        <Link
            href='/'
            className={cn('group inline-flex items-center gap-3 rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring', className)}
        >
            <span
                aria-hidden='true'
                className='h-5 w-2.5 -skew-x-[18deg] bg-race transition-transform duration-300 group-hover:scale-y-125'
            />

            <span className='font-heading text-lg font-semibold uppercase tracking-[0.12em] text-foreground'>
                Tarmac SL9 <span className='text-race-bright'>LTD</span>
            </span>
        </Link>
    )
}

export default BrandMark
